import PrivacyPolicy, { getStaticProps } from 'routes/public/PrivacyPolicy'

export { getStaticProps }

export default PrivacyPolicy
